@if (passengersWithBundleIcons$ | async; as passengers) {
  <h3 class="font-heading-4 ps-xsmall-b dn-tablet-down">
    {{ 'seatMap.passengersTitle' | finLocalization }}
  </h3>
  <div class="flex flex--wrap dn-mobile ps-medium-b">
    <button
      *ngFor="let passenger of passengers; let index = index"
      class="pax-selector font-body-1 ms-xsmall-y ms-xsmall-r ps-xsmall border rounded-medium flex flex--middle"
      [attr.data-pax-id]="passenger.id"
      [attr.data-testid]="'seatmap-passenger-indicator-' + passenger.id"
      [class.active]="passenger.active"
      (click)="handleClick(passenger.id, index)"
    >
      <fcom-icon [name]="SvgLibraryIcon.SINGLE_PAX" class="icon-medium"></fcom-icon>
      <div class="ms-xsmall-l font-body-1 flex flex--middle" data-hj-suppress>
        <span class="pax-name truncate overflow-hidden" data-hj-suppress
          >{{ passenger.traveler.firstName }} {{ passenger.traveler.lastName }}</span
        >
        @if (passenger.withInfant) {
          <span class="ps-xxsmall-l">
            ({{ 'seatMap.and' | finLocalization }} {{ passenger.withInfantFullName }} )
          </span>
        }
        @if (passenger.seatNumber) {
          <div
            [ngClass]="{
              'nordic-blue-900-text white-bg': passenger.active,
              'white-text nordic-blue-900-bg': !passenger.active,
            }"
            class="rounded-medium ms-xsmall-l flex flex--middle"
          >
            <span class="font-body-2 ms-xxsmall-x">{{ passenger.seatNumber }}</span>
            @if (passenger.bundleIcon) {
              <fcom-icon class="ms-xxsmall-r icon-small" [name]="passenger.bundleIcon"></fcom-icon>
            }
          </div>
        }
        @if (passenger.seatNumber && passenger.modifiableSeat !== false) {
          <fcom-icon-button
            class="close ms-xsmall-l flex flex--middle"
            [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
            [theme]="passenger.active ? IconButtonTheme.DARK_TERTIARY_GHOST : IconButtonTheme.LIGHT_TERTIARY_GHOST"
            [size]="IconButtonSize.SMALL"
            [aria]="{ label: 'seatMap.passengers.removeSeat' | finLocalization }"
            (clickBtn)="clearSelection(passenger.id)"
          >
          </fcom-icon-button>
        }
      </div>
    </button>
  </div>

  @if (options$ | async; as options) {
    <form [formGroup]="passengerForm" class="dn-tablet-up ps-medium-y">
      <fin-select-input
        class="fill"
        [parentForm]="passengerForm"
        [controlName]="'activeTravelerId'"
        [options]="options"
        [displayMargin]="false"
        [translationPrefix]="'seatMap.passengers'"
        [disableSelectOption]="true"
        [label]="
          'seatMap.passengers.label'
            | finLocalization
              : {
                  selected: activeTravelerIndex$ | async,
                  total: passengers.length,
                }
        "
        data-hj-suppress
      ></fin-select-input>
    </form>
  }
}
